module.exports = __webpack_public_path__ + "img/cute_handdrawn_1.4e45d5a7.png";